import React from "react";
import ScopeGroupListItem from "../../components/scopeGroup/ScopeGroupList/ScopeGroupListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ScopeGroupListPage = ()  => {

    useTitle(t`List Scope Group`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ScopeGroupListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ScopeGroupListPage;
